import Stripe from 'stripe';
import OrganizationService from "./services/organization-service";
import OrganizationSubscriptionService from "./services/organization-subscription-service";
import GlobalState from '../models/interfaces/global-state';
import { Organization } from '../models/interfaces/organization';
import { AddOnId } from '../models/enumerations/add-on-id';

export default class StripeUtil {
    public static stripe2 = require('stripe')(process.env.REACT_APP_STRIPE_SECRET_KEY);

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    public static checkAndUpdateHiddenLimit = async (state: GlobalState, products: any[], organization?: Organization) => {
        await OrganizationSubscriptionService.getByOrganizationId(state.organization.id!).then(async (orgSubs) => {
            await OrganizationService.get(orgSubs[0].organizationId).then(async (org) => {
                const sub = await StripeUtil.stripe2.subscriptions.retrieve(orgSubs[0].stripeAddOnSubscription);
                if (sub.schedule && org?.userLimit && org?.mySymmioLicenseCount) {
                    const subSched = StripeUtil.stripe2.subscriptionSchedules.retrieve(sub.schedule)
                    const phases: Stripe.SubscriptionSchedule.Phase[] = subSched?.phases || [];

                    // Get quantities with fallback to 0 if undefined
                    const lastItemQuantity: number = phases.at(-1)?.items.find(item => item.price === AddOnId.License.toString())?.quantity ?? 0;
                    const secondLastItemQuantity: number = phases.at(-2)?.items.find(item => item.price === AddOnId.License.toString())?.quantity ?? 0;
                    const toBeRemovedFromSchedule: number = secondLastItemQuantity - lastItemQuantity
                    const hiddenLimit = org.userLimit - toBeRemovedFromSchedule;
                    const amountOver = (org.mySymmioLicenseCount + 1) - (hiddenLimit)

                    // Update subscription schedule phase
                    // Retrieve existing subscription schedule
                    const subscriptionSchedule = await StripeUtil.stripe2.subscriptionSchedules.retrieve(sub.schedule);

                    // Check if subscription schedule has already been updated for the future month
                    // To do so, take last index of phase array and check if phase.start/end === subSched.current_phase
                    // If === then no future phase isn't created
                    // If !== then future phase is created and we want to update
                    const futurePhaseExists = !((subscriptionSchedule.phases.at(-1).start_date === subscriptionSchedule.current_phase.start_date) &&
                        (subscriptionSchedule.phases.at(-1).end_date === subscriptionSchedule.current_phase.end_date));
                    // We should always get in this as the only way we would have "AddOnsToBeRemoved" is if they've modified add-ons and created a subscription schedule
                    if (futurePhaseExists) {
                        // Update existing phase quantity
                        const index = subscriptionSchedule.phases.at(-1).items.findIndex((item: any) => item.price === products.find((item) => item.product.id === AddOnId.User).prices.find((item: any) => item.data.active === true).id);
                        subscriptionSchedule.phases.at(-1).items[index].quantity = subscriptionSchedule.phases.at(-1).items[index].quantity + amountOver
                        // Create new phases object
                        let phases: any[] = [];
                        subscriptionSchedule.phases.forEach(function (phase: any, index: any, array: any) {
                            let phaseItems: any[] = [];
                            phase.items.forEach(function (item: any) {
                                phaseItems.push({
                                    price: item.price,
                                    quantity: item.quantity,
                                })
                            })

                            // Check if we're on last iteration
                            if (index === array.length - 1) {
                                phases.push({
                                    items: phaseItems,
                                    iterations: 1,
                                })
                            }
                            else {

                                phases.push({
                                    items: phaseItems,
                                    start_date: phase.start_date,
                                    end_date: phase.end_date,
                                })
                            }
                        })

                        // Update existing phase            
                        await StripeUtil.stripe2.subscriptionSchedules.update(

                            sub.schedule,
                            {
                                phases: phases
                            },
                        )
                    }
                }
            })
            // }
        })
    }


    // #endregion Public Methods
}
